var selectors = {
    cartCount: '[data-cart-count]',
    cartCountBubble: '[data-cart-count-bubble]',
    cartDiscount: '[data-cart-discount]',
    cartDiscountTitle: '[data-cart-discount-title]',
    cartDiscountAmount: '[data-cart-discount-amount]',
    cartDiscountWrapper: '[data-cart-discount-wrapper]',
    cartErrorMessage: '[data-cart-error-message]',
    cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
    cartItem: '[data-cart-item]',
    cartItemDetails: '[data-cart-item-details]',
    cartItemDiscount: '[data-cart-item-discount]',
    cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
    cartItemDiscountTitle: '[data-cart-item-discount-title]',
    cartItemDiscountAmount: '[data-cart-item-discount-amount]',
    cartItemDiscountList: '[data-cart-item-discount-list]',
    cartItemFinalPrice: '[data-cart-item-final-price]',
    cartItemImage: '[data-cart-item-image]',
    cartItemLinePrice: '[data-cart-item-line-price]',
    cartItemOriginalPrice: '[data-cart-item-original-price]',
    cartItemPrice: '[data-cart-item-price]',
    cartItemPriceList: '[data-cart-item-price-list]',
    cartItemProperty: '[data-cart-item-property]',
    cartItemPropertyName: '[data-cart-item-property-name]',
    cartItemPropertyValue: '[data-cart-item-property-value]',
    cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
    cartItemRegularPrice: '[data-cart-item-regular-price]',
    cartItemTitle: '[data-cart-item-title]',
    cartItemVendor: '[data-cart-item-vendor]',
    cartItemOption: '[data-cart-item-option]',
    cartLineItems: '[data-cart-line-items]',
    cartNote: '[data-cart-notes]',
    cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
    cartQuantityErrorMessageWrapper: '[data-cart-quantity-error-message-wrapper]',
    cartRemove: '[data-cart-remove]',
    cartupdate: '[data-qtt]',
    cartStatus: '[data-cart-status]',
    cartSubtotal: '[data-cart-subtotal]',
    cartTableCell: '[data-cart-table-cell]',
    cartWrapper: '[data-cart-wrapper]',
    emptyPageContent: '[data-empty-page-content]',
    quantityInput: '[data-quantity-input]',
    quantityInputMobile: '[data-quantity-input-mobile]',
    quantityInputDesktop: '[data-quantity-input-desktop]',
    quantityLabelMobile: '[data-quantity-label-mobile]',
    quantityLabelDesktop: '[data-quantity-label-desktop]',
    inputQty: '[data-quantity-input]',
    thumbnails: '.cart__image',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    unitPriceGroup: '[data-unit-price-group]',
    editCart: '[data-cart-edit]',
    termsConditions: '[data-terms-conditions]',
    updateCartPC: '[data-cart-pc]',
    updateCartMB: '[data-mobile-cart]',
}

var classes = {
    cartNoCookies: 'cart--no-cookies',
    cartRemovedProduct: 'cart__removed-product',
    hide: 'hide',
    inputError: 'input--error',
}

var attributes = {
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemVendor: 'data-cart-item-vendor',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item',
}
//console.log(window.router);

function addProductToSideBar(e) {

if (this.ajaxEnabled) {
    /**
    * Cart container event delegation handler.
    * Adds event listeners to cart container instead of individual cart items
    * since the cart DOM is rebuilt when items are updated.
    */

    this.$container.on('change', selectors.cartNote, this._onNoteChange.bind(this))

    this.$container.on('click', selectors.cartRemove, this._onRemoveItem.bind(this))

    this._setupCartTemplates()
}

var $cart_item = $(e.currentTarget).parents('[data-cart-item]'),
  item_url = $cart_item.data('cart-item-url'),
  item_qty = $cart_item.data('cart-item-quantity'),
    item_handle = $cart_item.data('product-handle'),  
  $themeCart = this

var changeVariantQtt = function ($editCart) {
  $('form[data-edit-cart-form] [data-qtt-edcart]', $editCart)
    .off('click')
    .on('click', function (e) {
      var self = $(this)
      var $target = $(this).siblings('input');
            console.log($target);
      var currentVal = parseInt($target.val())
      if (self.hasClass('minus')) {
        if (currentVal >= 1) $target.val(currentVal - 1)
      } else {
        $target.val(currentVal + 1)
      }
    })
}

$.urlParam = function (name) {
  var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(item_url)
  return results[1] || 0
}

var $editCart = '#cart-edit-modal',
  $Close = $($editCart).find('.close'),
  $editCartContent = $($editCart).find('.cart-edit-modal'),
  current_variant = $.urlParam('variant'),
  new_variant = current_variant

$('[data-cart-edit-item-quantity] input', $editCart).val(item_qty)

// Guard: avoid /products/null.js or /products/undefined.js when item has no product-handle (e.g. add-on)
if (!item_handle || item_handle === 'null' || item_handle === 'undefined') {
  item_handle = null;
}
var xhr = item_handle ? $.ajax({
    type: 'GET',
    url: '/products/' + item_handle + '.js',
    cache: false,
    dataType: 'json',
    success: function (data) {
        // Now `data` is already in JSON format
        window._json = data;

        // Example: logging product data
        //console.log(window._json);

    $('[data-product-vendor-edit]', $editCartContent).text(window._json.vendor)
    $('[data-product-title-edit]', $editCartContent).text(window._json.title)
    var index = 0,
      imageSrc = window._json.featured_image,
      selected = ''
    $('[data-cart-edit-item-template] option', $editCart).remove()

    $.each(window._json.variants, function (i, e) {
      selected = ''
      if (current_variant == e.id) {
        index = i
        selected = 'selected="selected"'
        if (e.featured_image) {
          imageSrc = e.featured_image.src
        }
      }
      $('[data-cart-edit-item-template]', $editCart).append(
        '<option ' +
          (e.available ? 'value="' + e.id + '" ' : 'disabled="disabled" ') +
          selected +
          '>' +
          e.title +
          (e.available ? '' : ' - Sold out') +
          '</option>'
      )
    })

    $('[data-product-image-edit] img', $editCart).attr('src', imageSrc)
    var currentVariant = window._json.variants[index],
      _options = '',
      _option1 = [],
      _option2 = [],
      _option3 = []
    $.each(window._json.options, function (i, e) {
        var option_name = e.name;
      _options += '<th class="text-center" scope="col" data-option> ' + option_name + ' </th>'
      $.each(window._json.variants, function (j, el) {
        if (i == 0) {
          if ($.inArray(el.options[i], _option1) === -1) _option1.push(el.options[i])
        } else if (i == 1) {
          if ($.inArray(el.options[i], _option2) === -1) _option2.push(el.options[i])
        } else {
          if ($.inArray(el.options[i], _option3) === -1) _option3.push(el.options[i])
        }
      })
    })

    $('[data-cart-edit-head] tr', $editCart).find('[data-option]').remove()
    $('[data-cart-edit-head] tr', $editCart).prepend(_options)

    var _opt = ''
    if (_option1.length) {
      _opt +=
        '<td class="cart-edit__option text-center option__1" data-cart-edit-item-option><select class="cart-edit-option-selector product-form__input form-control" id="CartEditOptionSelector-1" data-index="option1" data-option-index="1">'
      $.each(_option1, function (i, e) {
        selected = ''
        if (currentVariant.option1 == e) {
          selected = 'selected="selected"'
        }
        _opt += '<option value="' + e + '" ' + selected + '>' + e + '</option>'
      })
      _opt += '</select>'
      _opt +=
        '<span class="icon-dropdown"><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 551.13 551.13" height="512" viewBox="0 0 551.13 551.13" width="512"><path d="m275.565 361.679-223.897-223.896h-51.668l275.565 275.565 275.565-275.565h-51.668z"></path></svg></span>'
      _opt += '</td>'
    }
    if (_option2.length) {
      _opt +=
        '<td class="cart-edit__option text-center option__2" data-cart-edit-item-option><select class="cart-edit-option-selector product-form__input form-control" id="CartEditOptionSelector-2" data-index="option2" data-option-index="2">'
      $.each(_option2, function (i, e) {
        selected = ''
        if (currentVariant.option2 == e) {
          selected = 'selected="selected"'
        }
        _opt += '<option value="' + e + '" ' + selected + '>' + e + '</option>'
      })
      _opt += '</select>'
      _opt +=
        '<span class="icon-dropdown"><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 551.13 551.13" height="512" viewBox="0 0 551.13 551.13" width="512"><path d="m275.565 361.679-223.897-223.896h-51.668l275.565 275.565 275.565-275.565h-51.668z"></path></svg></span>'
      _opt += '</td>'
    }
    if (_option3.length) {
      _opt +=
        '<td class="cart-edit__option text-center option__3" data-cart-edit-item-option><select class="cart-edit-option-selector product-form__input form-control" id="CartEditOptionSelector-3" data-index="option3" data-option-index="3">'
      $.each(_option3, function (i, e) {
        selected = ''
        if (currentVariant.option3 == e) {
          selected = 'selected="selected"'
        }
        _opt += '<option value="' + e + '" ' + selected + '>' + e + '</option>'
      })
      _opt += '</select>'
      _opt +=
        '<span class="icon-dropdown"><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 551.13 551.13" height="512" viewBox="0 0 551.13 551.13" width="512"><path d="m275.565 361.679-223.897-223.896h-51.668l275.565 275.565 275.565-275.565h-51.668z"></path></svg></span>'
      _opt += '</td>'
    }
    var $tr = $('[data-cart-edit-body] tr:eq(0)', $editCart).clone()
    $('[data-cart-edit-body] tr', $editCart).remove()
    $('[data-cart-edit-body]', $editCart).append($tr)
    $('[data-cart-edit-body] tr', $editCart).find('[data-cart-edit-item-option]').remove()
    $('[data-cart-edit-body] tr', $editCart).prepend(_opt)
    $('[data-cart-edit-body] tr', $editCart).find('[data-cart-edit-remove]').hide()

    //----------------------

    if (_option1.length) {
      $themeCart.updateVariant(
        window._json,
        $editCart,
        currentVariant,
        currentVariant.option1,
        'option1'
      )
    }

    $themeCart.updatePrice(currentVariant, $editCart);

    var $product_clone = $('[data-cart-edit-item]:last-child', $editCart).clone()

    $(document)
      .off('change', '.cart-edit-option-selector')
      .on('change', '.cart-edit-option-selector', function (e) {
        var $row = $(e.currentTarget).parents('[data-cart-edit-item]');

                if (typeof _ !== 'undefined') {
                  _.map($('.cart-edit-option-selector', $row), function (element) {
                  console.error('Lodash is loaded');
                  });
                } else {
                  console.error('Lodash is not loaded');
                }
        var currentOptions = _.map($('.cart-edit-option-selector', $row), function (element) {
          var $element = $(element)
          var currentOption = {}

          currentOption.value = $element.val()
          currentOption.index = $element.data('index')

          return currentOption
        })

        currentOptions = _.compact(currentOptions)

        var variants = window._json.variants

        var found = _.find(variants, function (variant) {
          return currentOptions.every(function (values) {
            return _.isEqual(variant[values.index], values.value)
          })
        })

        if (found) {
          $('[data-cart-edit-item-template]', $row).val(found.id)
          $themeCart.updatePrice(found, $row)
        }

        var selectedOption1
        var selectedOption2
        var selectedOption3

        if (found == undefined || found.available == false) {
          selectedOption1 = $('#CartEditOptionSelector-1', $row).find('option:selected').val()
          selectedOption2 = $('#CartEditOptionSelector-2', $row).find('option:selected').val()
          selectedOption3 = $('#CartEditOptionSelector-3', $row).find('option:selected').val()

          $('#CartEditOptionSelector-3 option', $row).each(function () {
            var swatchVal = $(this).val()
            var optionSoldout = variants.find(function (variant) {
              return (
                variant.option1 == selectedOption1 &&
                variant.option2 == selectedOption2 &&
                variant.option3 == swatchVal &&
                variant.available
              )
            })

            if (optionSoldout == undefined) {
              $(this).attr('disabled', 'disabled').prop('selected', false)
            } else {
              $(this).removeAttr('disabled', 'disabled').prop('selected', true)
            }
          })

          currentOptions = _.map($('.cart-edit-option-selector', $row), function (element) {
            var $element = $(element)
            var currentOption = {}

            currentOption.value = $element.val()
            currentOption.index = $element.data('index')

            return currentOption
          })

          currentOptions = _.compact(currentOptions)

          found = _.find(variants, function (variant) {
            return currentOptions.every(function (values) {
              return _.isEqual(variant[values.index], values.value)
            })
          })

          if (found) {
            $('[data-cart-edit-item-template]', $row).val(found.id)
            $themeCart.updatePrice(found, $row)
          }

          if (found == undefined || found.available == false) {
            $('#CartEditOptionSelector-3 option', $row).each(function () {
              var swatchVal = $(this).val()
              var optionSoldout = variants.find(function (variant) {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option3 == swatchVal &&
                  variant.available
                )
              })

              if (optionSoldout == undefined) {
                $(this).attr('disabled', 'disabled').prop('selected', false)
              } else {
                $(this).removeAttr('disabled', 'disabled').prop('selected', true)
              }
            })

            selectedOption3 = $('#CartEditOptionSelector-3', $row)
              .find('option:selected')
              .val()

            $('#CartEditOptionSelector-2 option', $row).each(function () {
              var swatchVal = $(this).val()
              var optionSoldout = variants.find(function (variant) {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option3 == selectedOption3 &&
                  variant.option2 == swatchVal &&
                  variant.available
                )
              })

              if (optionSoldout == undefined) {
                $(this).attr('disabled', 'disabled').prop('selected', false)
              } else {
                $(this).removeAttr('disabled', 'disabled').prop('selected', true)
              }
            })

            currentOptions = _.map($('.cart-edit-option-selector', $row), function (element) {
              var $element = $(element)
              var currentOption = {}

              currentOption.value = $element.val()
              currentOption.index = $element.data('index')

              return currentOption
            })

            currentOptions = _.compact(currentOptions)

            found = _.find(variants, function (variant) {
              return currentOptions.every(function (values) {
                return _.isEqual(variant[values.index], values.value)
              })
            })

            console.log(found)

            if (found) {
              $('[data-cart-edit-item-template]', $row).val(found.id)
              $themeCart.updatePrice(found, $row)
            }
          }
        }

        $themeCart.updateVariant(
          window._json,
          $row,
          found,
          $(e.currentTarget).val(),
          $(e.currentTarget).data('index')
        )
      })
    // change quantity edit cart
    changeVariantQtt($editCart)

    $('form[data-edit-cart-form]', $editCart)
      .off('submit')
      .on('submit', function (e) {
        e.preventDefault()
        var arrVariant = []
        $('[data-cart-edit-item]', $editCart).each(function (i, el) {
          var variant = $('[data-cart-edit-item-template]', $(el)).val()
          var qty = parseInt($('[data-cart-edit-item-quantity] input', $(el)).val())
          var currentOption = {}
          currentOption.value = variant
          currentOption.qty = qty
          var k = 0
          $.each(arrVariant, function (j, v) {
            if (variant == v.value) {
              k = 1
              if (qty > v.qty) {
                v.qty = qty
              }
            }
          })
          if (k == 0) arrVariant.push(currentOption)
        })

        var k = 0
        $.each(arrVariant, function (j, v) {
          if (current_variant == v.value) {
            k = 1
          }
        })

        if (k == 0) {
          //remove
          var key = $cart_item.attr(attributes.cartItemKey)
          var index = parseInt($cart_item.attr(attributes.cartItemIndex))

          var params = {
            url: '/cart/change.js',
            data: { quantity: 0, line: index },
            dataType: 'json',
            async: false,
          }

          $.post(params).done(function (cart) {}.bind(this))
        }

        k = 0
        $.each(arrVariant, function (j, v) {
          if (current_variant == v.value) {
            if (item_qty != v.qty) {
              if (v.qty >= 0) {
                $themeCart._updateItemQuantity(
                  $cart_item.find('[data-quantity-input]').data('quantity-item'),
                  $cart_item,
                  $(
                    '[data-cart-edit-item-quantity] input',
                    $('[data-cart-edit-body] tr:eq(0)', $editCart)
                  ),
                  v.qty
                )
                k++

                if (k == arrVariant.length) {
                  //get new cart
                  $.getJSON('/cart.js').then(function (cart) {
                    $themeCart._setCartCountBubble(cart.item_count)
                    $themeCart._createCart(cart)
                    theme.HaloAddOn.progressBarShipping()
                    theme.HaloAddOn.removeLoadingPopup()
                    $('a.close', $editCart).trigger('click')
                  })
                }
              }
            } else {
              k++
              if (k == arrVariant.length) {
                //get new cart
                $.getJSON('/cart.js').then(function (cart) {
                  $themeCart._setCartCountBubble(cart.item_count)
                  $themeCart._createCart(cart)
                  theme.HaloAddOn.progressBarShipping()
                  theme.HaloAddOn.removeLoadingPopup()
                  $('a.close', $editCart).trigger('click')
                })
              }
            }
          } else {
            if (v.qty > 0) {
              var params = {
                url: '/cart/add.js',
                data: 'form_type=product&quantity=' + v.qty + '&utf8=✓&id=' + v.value,
                dataType: 'json',
                async: false,
              }

              $.post(params)
                .done(
                  function (item) {
                    $themeCart._hideErrorMessage($editCart)
                    theme.HaloAddOn.loadingPopup()
                    k++
                    if (k == arrVariant.length) {
                      //get new cart
                      $.getJSON('/cart.js').then(function (cart) {
                        $themeCart._setCartCountBubble(cart.item_count)
                        $themeCart._createCart(cart)
                        theme.HaloAddOn.progressBarShipping()
                        theme.HaloAddOn.removeLoadingPopup()
                        $('a.close', $editCart).trigger('click')
                      })
                    }
                                      window.location.reload();
                  }.bind(this)
                )
                .fail(
                  function (response) {
                    var errorMessage = response.responseJSON
                      ? response.responseJSON.description
                      : theme.strings.cartError
                    theme.HaloAddOn.removeLoadingPopup()
                    $themeCart._showErrorMessage(errorMessage, $editCart)
                  }.bind(this)
                )
            }
          }
        });
        return false
                window.location.reload();
      })

    $(document)
      .off('click', '[data-cart-edit-remove]')
      .on('click', '[data-cart-edit-remove]', function (e) {
        e.preventDefault()
        var $row = $(e.currentTarget).parents('[data-cart-edit-item]')

        $row.remove()
        return false
      })

    $('.product-addmore-button', $editCart)
      .off('click')
      .on('click', function (e) {
        var $tr = $product_clone.clone()
        $tr.find('[data-cart-edit-remove]').show()
        $('[data-cart-edit-body]', $editCart).append($tr)
      })

    if (theme.HaloAddOn.checkNeedToConvertCurrency()) {
      Currency.convertAll(
        window.shop_currency,
        $('#currencies .active').attr('data-currency'),
        'span.money',
        'money_format'
      )
    }
  },
  complete: function () {},
}) : null;
}

function updateVariant(json, $editCart, currentOption, option_value, option_change) {
    var variants = json.variants
    var options = $('.cart-edit-option-selector', $editCart)
    var selectedOption1 = $('#CartEditOptionSelector-1', $editCart).find('option:selected').val()
    var selectedOption2 = $('#CartEditOptionSelector-2', $editCart).find('option:selected').val()
    var selectedOption3 = $('#CartEditOptionSelector-3', $editCart).find('option:selected').val()

    options.each(function () {
        var optionIndex = $(this).data('option-index')
        var option = $(this).find('option')
        switch (optionIndex) {
            case 1:
                option.each(function () {
                    var optionVal = $(this).val()
                    var optionSoldout = variants.find(function (variant) {
                        return variant.option1 == optionVal && variant.available
                    })
                    if (optionSoldout == undefined) {
                        $(this).attr('disabled', 'disabled')
                    } else {
                        $(this).removeAttr('disabled', 'disabled')
                    }
                })
                break
            case 2:
                option.each(function () {
                    var optionVal = $(this).val()
                    var optionSoldout = variants.find(function (variant) {
                        return (
                            variant.option1 == selectedOption1 &&
                            variant.option2 == optionVal &&
                            variant.available
                        )
                    })
                    if (optionSoldout == undefined) {
                        $(this).attr('disabled', 'disabled')
                    } else {
                        $(this).removeAttr('disabled', 'disabled')
                    }
                })
                break
            case 3:
                option.each(function () {
                    var optionVal = $(this).val()
                    var optionSoldout = variants.find(function (variant) {
                        return (
                            variant.option1 == selectedOption1 &&
                            variant.option2 == selectedOption2 &&
                            variant.option3 == optionVal &&
                            variant.available
                        )
                    })

                    if (optionSoldout == undefined) {
                        $(this).attr('disabled', 'disabled')
                    } else {
                        $(this).removeAttr('disabled', 'disabled')
                    }
                })
                break
        }
    })
}

function updatePrice(variant, $container) {
    var $priceContainer = $('[data-price]', $container)
    var $regularPrice = $('[data-regular-price]', $priceContainer)
    var $salePrice = $('[data-sale-price]', $priceContainer)
    var $unitPrice = $('[data-unit-price]', $priceContainer)
    var $unitPriceBaseUnit = $('[data-unit-price-base-unit]', $priceContainer)

    // Reset product price state
    $priceContainer
        .removeClass('price--unavailable')
        .removeClass('price--on-sale')
        .removeClass('price--unit-available')
        .removeAttr('aria-hidden')

    // Unavailable
    if (!variant) {
        $priceContainer.addClass('price--unavailable').attr('aria-hidden', true)

        return
    }

    // On sale
    var quantity = $('[data-cart-edit-item-quantity] input', $container).val();

    if (variant.compare_at_price > variant.price) {
        // Regular price
        $regularPrice.html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
        // Sale price
        $salePrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat))
        $priceContainer.addClass('price--on-sale')
    } else {
        // Regular price
        $regularPrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat))
        // Sale price
        $salePrice.html('')
    }

    // Unit price
    if (variant.unit_price) {
        $unitPrice.html(theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat))
        $unitPriceBaseUnit.html(
            variant.unit_price_measurement.reference_value === 1
                ? variant.unit_price_measurement.reference_unit
                : variant.unit_price_measurement.reference_value +
                        variant.unit_price_measurement.reference_unit
        )
        $priceContainer.addClass('price--unit-available')
    }
}

function QuickShop(container) {
    var $product = (theme.product_cart_grid.$container = container)

    this.productSingleObject = JSON.parse($product.attr('data-json-product'))
    console.log('$product', $product)

    var productId = this.productSingleObject.id

    theme.product_cart_grid.selectors = {
        addToCart: '[data-edit-cart-add-to-cart]',
        addToCartText: '[data-edit-cart-add-to-cart]',
        cartCount: '[data-cart-count]',
        cartCountBubble: '[data-cart-count-bubble]',
        cartPopup: '[data-cart-popup]',
        cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
        cartPopupClose: '[data-cart-popup-close]',
        cartPopupDismiss: '[data-cart-popup-dismiss]',
        cartPopupImage: '[data-cart-popup-image]',
        cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
        cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
        cartPopupPlaceholderSize: '[data-placeholder-size]',
        cartPopupProductDetails: '[data-cart-popup-product-details]',
        cartPopupQuantity: '[data-cart-popup-quantity]',
        cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
        cartPopupTitle: '[data-cart-popup-title]',
        cartPopupWrapper: '[data-cart-popup-wrapper]',
        loader: '[data-loader]',
        loaderStatus: '[data-loader-status]',
        originalSelectorId: '#ProductSelect-' + productId,
        productForm: '[data-product-edit-form]',
        errorMessage: '[data-error-message]',
        errorMessageWrapper: '[data-error-message-wrapper]',
        singleOptionSelector: '.single-option-selector-quick',
        originalSelectorId: '[data-product-item-template]',
        priceContainer: '[data-price]',
        regularPrice: '[data-regular-price]',
        salePrice: '[data-sale-price]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        close: '.close',
    }

    theme.product_cart_grid.classes = {
        cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
        hidden: 'hide',
        visibilityHidden: 'visibility-hidden',
        cartImage: 'cart-popup-item__image',
        productFormErrorMessageWrapperHidden: 'product-form__error-message-wrapper--hidden',
        activeClass: 'active-thumb',
        variantSoldOut: 'product-form--variant-sold-out',
        productOnSale: 'price--on-sale',
        productUnitAvailable: 'price--unit-available',
        productUnavailable: 'price--unavailable',
        productSoldOut: 'price--sold-out',
    }
    theme.product_cart_grid._show_quickshop(this.productSingleObject)
}
  // popup add to cart grid
function initAddToCartGrid() {
    $(document)
        .off('click', '[data-add-cart-color]')
        .on('click', '[data-add-cart-color]', function (evt) {
            evt.preventDefault()
            evt.stopPropagation()
            theme.HaloAddOn.loadingPopup()
            var self = $(this),
                $product = self.parents('.product-card')
            if (self.hasClass('soldout')) {
                return false
            }
            $product
                .find('[data-add-cart-color]')
                .removeAttr('disabled')
                .removeClass('soldout')
                .text('Add To Cart')
            window.productSingleObject = JSON.parse($product.attr('data-json-product'))
            var productId = window.productSingleObject.id
            var variant = theme.product_cart_grid._getVariantFromOptions($product)
            if (!variant) {
                return
            }

            var params = {
                url: '/cart/add.js',
                data: 'form_type=product&quantity=1&utf8=✓&id=' + variant.id,
                dataType: 'json',
            }

            $.post(params)
                .done(
                    function (item) {
                        theme.product_cart_grid._hideErrorMessage($product)
                        // remove old item

                        // Salesforce Interaction Studio tracking
                        if (window.location.hostname.includes('shiels') && window.theme && window.theme.trackAddToCart) {
                            window.theme.trackAddToCart(item);
                        }

                        $.getJSON('/cart.js').then(
                            function (cart) {
                                theme.product_cart_grid._setCartQuantity(cart.item_count)
                                theme.product_cart_grid._setCartCountBubble(cart.item_count)
                                theme.HaloAddOn.removeLoadingPopup()
                                theme.HaloAddOn._setupSideCart()
                            }.bind(this)
                        )
                    }.bind(this)
                )
                .fail(
                    function (response) {
                        var errorMessage = response.responseJSON
                            ? response.responseJSON.description
                            : theme.strings.cartError
                        theme.product_cart_grid._showErrorMessage(errorMessage, $product)
                    }.bind(this)
                )
        })

    $('.product-card__variant .product-card__variant--item label').on('click', function () {
        var self = $(this),
            $product = self.parents('.product-card'),
            $variantName = self.data('name')
        if (self.parent().hasClass('soldout')) {
            $product
                .find('[data-add-cart-color]')
                .attr('disabled', 'disabled')
                .addClass('soldout')
                .text('Soldout')
            return false
        }
        $product
            .find('[data-add-cart-color]')
            .removeAttr('disabled')
            .removeClass('soldout')
            .text('Add To Cart')
    })

    var btnAddToCartGr = '[data-add-cart-grid]'
    $(document).on('click', btnAddToCartGr, function (evt) {
        evt.preventDefault()
        evt.stopPropagation()
        var $product = $(evt.currentTarget).parents('.product-card')

        if (!$product[0].hasAttribute('data-json-product')) {
            theme.product_cart_grid.get_json_product($product)

            var myVar = setInterval(function () {
                if ($product[0].hasAttribute('data-json-product')) {
                    QuickShop($product)
                    $('#product_add_cart_grid').modal('show')
                    clearInterval(myVar)
                }
            }, 500)

            return
        }

        QuickShop($product)
        $('#product_add_cart_grid').modal('show')
    })

    $(document)
        .off('mouseover', '.product-card')
        .on('mouseover', '.product-card', function (e) {
            e.preventDefault()
            var $product = $(this)
            if (!$product[0].hasAttribute('data-json-product')) {
                theme.product_cart_grid.get_json_product($product)
            }
        })
}


function _updateItemQuantity(itemIndex, $itemElement, $itemQtyInputs, value) {
    var key = $itemElement.attr(attributes.cartItemKey);
    var index = $itemElement.attr(attributes.cartItemIndex);

    var params = {
        url: '/cart/change.js',
        data: {
            quantity: value,
            line: index,
        },
        dataType: 'json',
    };

    console.log('data', params.data);
    theme.HaloAddOn.loadingPopup();

    $.post(params)
        .done(function (state) {
            if (state.item_count === 0) {
                this._emptyCart();
            } else {
                this._createCart(state);
                if (value === 0) {
                    if ($itemElement.length) {
                        this._showRemoveMessage($itemElement.clone()); // Ensure $itemElement is valid
                    } else {
                        console.error('Item element is not found');
                    }
                } else {
                    var $lineItem = $('[data-cart-item-key="' + key + '"]');
                    var item = this.getItem(key, state);

                    if (value != item.quantity) {
                        this._showQuantityErrorMessages2(item.quantity, $lineItem);
                    }

                    $(selectors.quantityInput, $lineItem).focus();
                    this._updateLiveRegion(item);
                    theme.HaloAddOn.progressBarShipping();
                }
            }

            this._setCartCountBubble(state.item_count);
            window.location.reload(); // Reload the page after a successful update
        }.bind(this))
        .fail(function () {
            this._showCartError($itemQtyInputs);
        }.bind(this))
        .always(function () {
            theme.HaloAddOn.removeLoadingPopup();
        });
}


function _createCart(state) {
    var cartDiscountList = this._createCartDiscountList(state)
    $(selectors.emptyPageContent).addClass(classes.hide)
    $(selectors.cartWrapper).removeClass(classes.hide)

    $(selectors.cartLineItems, this.$container).html(this._createLineItemList(state))

    this.setQuantityFormControllers()
    this._updateVlueQuantity()

    $(selectors.cartNote, this.$container).val(state.note)

    if (cartDiscountList.length === 0) {
        $(selectors.cartDiscountWrapper, this.$container).html('').addClass(classes.hide)
    } else {
        $(selectors.cartDiscountWrapper, this.$container)
            .html(cartDiscountList)
            .removeClass(classes.hide)
    }

    $(selectors.cartSubtotal, this.$container).html(
        theme.Currency.formatMoney(state.total_price, theme.moneyFormatWithCurrency)
    )
}

function _setupCartTemplates() {
    this.$itemTemplate = $(selectors.cartItem, this.$container).first().clone()
    this.$itemDiscountTemplate = $(selectors.cartItemDiscount, this.$itemTemplate).clone()
    this.$itemOptionTemplate = $(selectors.cartItemOption, this.$itemTemplate).clone()
    this.$itemPropertyTemplate = $(selectors.cartItemProperty, this.$itemTemplate).clone()
    this.$itemPriceListTemplate = $(selectors.cartItemPriceList, this.$itemTemplate).clone()
    this.$itemLinePriceTemplate = $(selectors.cartItemLinePrice, this.$itemTemplate).clone()
    this.$cartDiscountTemplate = $(selectors.cartDiscount, this.$container).clone()
}

function _createCartDiscountList(cart) {
    return $.map(
        cart.cart_level_discount_applications,
        function (discount) {
            var $discount = this.$cartDiscountTemplate.clone()
            $discount.find(selectors.cartDiscountTitle).text(discount.title)
            $discount
                .find(selectors.cartDiscountAmount)
                .html(theme.Currency.formatMoney(discount.total_allocated_amount, theme.moneyFormat))
            return $discount[0]
        }.bind(this)
    )
}

function _createLineItemList(state) {
    _setupCartTemplates();
    getSizedImageUrl();
    // Ensure that $itemTemplate and $itemPriceListTemplate are defined
    if (!this.$itemTemplate || !this.$itemPriceListTemplate) {
        console.error('Template elements are not defined');
        return [];
    }

    return $.map(
        state.items,
        function (item, index) {
            // Ensure that $itemTemplate and $itemPriceListTemplate are valid jQuery objects
            var $item = this.$itemTemplate.clone();
            var $itemPriceList = this.$itemPriceListTemplate.clone();

            // Check if clone was successful
            console.log($item);
            console.log($itemPriceList);

            // Assuming _setLineItemAttributes and other methods are correctly defined
            this._setLineItemAttributes($item, item, index);
            this._setLineItemImage($item, item.featured_image);

            $(selectors.cartItemTitle, $item).text(item.product_title).attr('href', item.url);
            $(selectors.cartItemVendor, $item).text(item.vendor);

            var productDetailsList = this._createProductDetailsList(
                item.product_has_only_default_variant,
                item.options_with_values,
                item.properties
            );
            this._setProductDetailsList($item, productDetailsList);

            this._setItemRemove($item, item.title);

            $itemPriceList.html(
                this._createItemPrice(
                    item.original_price,
                    item.final_price,
                    this.$itemPriceListTemplate
                )
            );

            if (item.unit_price_measurement) {
                $itemPriceList.append(
                    this._createUnitPrice(
                        item.unit_price,
                        item.unit_price_measurement,
                        this.$itemPriceListTemplate
                    )
                );
            }

            this._setItemPrice($item, $itemPriceList);

            var itemDiscountList = this._createItemDiscountList(item);
            this._setItemDiscountList($item, itemDiscountList);

            this._setQuantityInputs($item, item, index);

            var itemLinePrice = this._createItemPrice(
                item.original_line_price,
                item.final_line_price,
                this.$itemLinePriceTemplate
            );
            this._setItemLinePrice($item, itemLinePrice);

            return $item[0];
        }.bind(this)
    );
}


function _setLineItemAttributes($item, item, index) {
    $item
        .attr(attributes.cartItemKey, item.key)
        .attr(attributes.cartItemUrl, item.url)
        .attr(attributes.cartItemVendor, item.vendor)
        .attr(attributes.cartItemTitle, item.title)
        .attr(attributes.cartItemIndex, index + 1)
        .attr(attributes.cartItemQuantity, item.quantity)
}

function _setLineItemImage($item, featuredImage) {
    var $image = $(selectors.cartItemImage, $item)

    var sizedImageUrl =
        featuredImage.url !== null ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190') : null

    if (sizedImageUrl) {
        $image.attr('alt', featuredImage.alt).attr('src', sizedImageUrl).removeClass(classes.hide)
    } else {
        $image.remove()
    }
}

function _setProductDetailsList($item, productDetailsList) {
    var $itemDetails = $(selectors.cartItemDetails, $item)

    if (productDetailsList.length === 0) {
        $itemDetails.addClass(classes.hide).text('')
    } else {
        $itemDetails.removeClass(classes.hide).html(productDetailsList)
    }
}

function _setItemPrice($item, price) {
    $(selectors.cartItemPrice, $item).html(price)
}

function _setItemDiscountList($item, discountList) {
    var $itemDiscountList = $(selectors.cartItemDiscountList, $item)

    if (discountList.length === 0) {
        $itemDiscountList.html('').addClass(classes.hide)
    } else {
        $itemDiscountList.html(discountList).removeClass(classes.hide)
    }
}

function _setItemRemove($item, title) {
    var removeLabel = theme.strings && theme.strings.removeLabel 
        ? theme.strings.removeLabel 
        : 'Remove [product]'; // Fallback label

    $(selectors.cartRemove, $item).attr(
        'aria-label',
        removeLabel.replace('[product]', title)
    );
}

function _setQuantityInputs($item, item, index) {
    $(selectors.quantityInputMobile, $item)
        .attr('id', 'updates_' + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity)

    $(selectors.quantityInputDesktop, $item)
        .attr('id', 'updates_large_' + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity)

    $(selectors.quantityLabelMobile, $item).attr('for', 'updates_' + item.key)

    $(selectors.quantityLabelDesktop, $item).attr('for', 'updates_large_' + item.key)
}

function setQuantityFormControllers() {
    console.log('Media Query List:', this.mql); // Check if this.mql is defined
    console.log('Media Query Matches:', this.mql ? this.mql.matches : 'Not defined'); // Check if matches property is available

    if (this.mql && this.mql.matches) {
        $(selectors.quantityInputDesktop).attr('name', 'updates[]');
        $(selectors.quantityInputMobile).removeAttr('name');
    } else {
        $(selectors.quantityInputMobile).attr('name', 'updates[]');
        $(selectors.quantityInputDesktop).removeAttr('name');
    }
}

function _setItemLinePrice($item, price) {
    $(selectors.cartItemLinePrice, $item).html(price)
}

function _createProductDetailsList(product_has_only_default_variant, options, properties) {
    var optionsPropertiesHTML = []

    if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(this._getOptionList(options))
    }

    if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(this._getPropertyList(properties))
    }

    return optionsPropertiesHTML
}

function _getOptionList(options) {
    return $.map(
        options,
        function (option) {
            var $optionElement = this.$itemOptionTemplate.clone()

            $optionElement.text(option.value).removeClass(classes.hide)

            return $optionElement[0]
        }.bind(this)
    )
}

function _getPropertyList(properties) {
    var propertiesArray = properties !== null ? Object.entries(properties) : []

    return $.map(
        propertiesArray,
        function (property) {
            var $propertyElement = this.$itemPropertyTemplate.clone()

            // Line item properties prefixed with an underscore are not to be displayed
            if (property[0].charAt(0) === '_') return

            // if the property value has a length of 0 (empty), don't display it
            if (property[1].length === 0) return

            $propertyElement.find(selectors.cartItemPropertyName).text(property[0])

            if (property[0].indexOf('/uploads/') === -1) {
                $propertyElement.find(selectors.cartItemPropertyValue).text(': ' + property[1])
            } else {
                $propertyElement
                    .find(selectors.cartItemPropertyValue)
                    .html(': <a href="' + property[1] + '"> ' + property[1].split('/').pop() + '</a>')
            }

            $propertyElement.removeClass(classes.hide)

            return $propertyElement[0]
        }.bind(this)
    )
}

function _createItemPrice(original_price, final_price, $priceTemplate) {
    if (original_price !== final_price) {
        var $discountedPrice = $(selectors.cartItemDiscountedPriceGroup, $priceTemplate).clone()

        $(selectors.cartItemOriginalPrice, $discountedPrice).html(
            theme.Currency.formatMoney(original_price, theme.moneyFormat)
        )
        $(selectors.cartItemFinalPrice, $discountedPrice).html(
            theme.Currency.formatMoney(final_price, theme.moneyFormat)
        )
        $discountedPrice.removeClass(classes.hide)

        return $discountedPrice[0]
    } else {
        var $regularPrice = $(selectors.cartItemRegularPriceGroup, $priceTemplate).clone()

        $(selectors.cartItemRegularPrice, $regularPrice).html(
            theme.Currency.formatMoney(original_price, theme.moneyFormat)
        )

        $regularPrice.removeClass(classes.hide)

        return $regularPrice[0]
    }
}

function _createUnitPrice(unitPrice, unitPriceMeasurement, $itemPriceGroup) {
    var $unitPriceGroup = $(selectors.unitPriceGroup, $itemPriceGroup).clone()

    var unitPriceBaseUnit =
        (unitPriceMeasurement.reference_value !== 1 ? unitPriceMeasurement.reference_value : '') +
        unitPriceMeasurement.reference_unit

    $(selectors.unitPriceBaseUnit, $unitPriceGroup).text(unitPriceBaseUnit)
    $(selectors.unitPrice, $unitPriceGroup).html(
        theme.Currency.formatMoney(unitPrice, theme.moneyFormat)
    )

    $unitPriceGroup.removeClass(classes.hide)

    return $unitPriceGroup[0]
}

function _createItemDiscountList(item) {
    return $.map(
        item.line_level_discount_allocations,
        function (discount) {
            var $discount = this.$itemDiscountTemplate.clone()
            $discount.find(selectors.cartItemDiscountTitle).text(discount.discount_application.title)
            $discount
                .find(selectors.cartItemDiscountAmount)
                .html(theme.Currency.formatMoney(discount.amount, theme.moneyFormat))
            return $discount[0]
        }.bind(this)
    )
}

function _showQuantityErrorMessages(itemElement) {
    $(selectors.cartQuantityErrorMessage, itemElement).text(theme.strings.quantityMinimumMessage)

    $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(classes.hide)

    $(selectors.inputQty, itemElement).addClass(classes.inputError).focus()
}

function _showQuantityErrorMessages2(quantity, itemElement) {
    $(selectors.cartQuantityErrorMessage, itemElement).text(
        theme.strings.cartErrorMaximum.replace('[quantity]', quantity)
    )

    $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(classes.hide)

    $(selectors.inputQty, itemElement).addClass(classes.inputError).focus()
}

function _hideQuantityErrorMessage() {
    var $errorMessages = $(selectors.cartQuantityErrorMessageWrapper).addClass(classes.hide)

    $(selectors.cartQuantityErrorMessage, $errorMessages).text('')

    $(selectors.inputQty, this.$container).removeClass(classes.inputError)
}

function _handleThumbnailClick(evt) {
    var url = $(evt.target).closest(selectors.cartItem).data('cart-item-url')

    window.location.href = url
}

function _onNoteChange(evt) {
    var note = evt.currentTarget.value
    this._hideCartError()
    this._hideQuantityErrorMessage()

    var params = {
        url: '/cart/update.js',
        data: {
            note: note,
        },
        dataType: 'json',
    }

    $.post(params).fail(
        function () {
            this._showCartError(evt.currentTarget)
        }.bind(this)
    )
}

function _showCartError(elementToFocus) {
    $(selectors.cartErrorMessage).text(theme.strings.cartError)

    $(selectors.cartErrorMessageWrapper).removeClass(classes.hide)

    elementToFocus.focus()
}

function _hideCartError() {
    $(selectors.cartErrorMessageWrapper).addClass(classes.hide)
    $(selectors.cartErrorMessage).text('')
}

function _onRemoveItem(evt) {
    evt.preventDefault()
    var $remove = $(evt.target)
    var $lineItem = $remove.closest(selectors.cartItem)
    var index = $lineItem.attr(attributes.cartItemIndex)
    this._hideCartError()

    var params = {
        url: '/cart/change.js',
        data: {
            quantity: 0,
            line: index,
        },
        dataType: 'json',
    }

    $.post(params)
        .done(
            function (state) {
                if (state.item_count === 0) {
                    this._emptyCart()
                } else {
                    this._createCart(state)
                    this._showRemoveMessage($lineItem.clone())
                    theme.HaloAddOn.progressBarShipping()
                }

                this._setCartCountBubble(state.item_count);
                window.location.reload();
            }.bind(this)
        )
        .fail(
            function () {
                this._showCartError(null)
            }.bind(this)
        )
}

function _showRemoveMessage(lineItem) {
    var index = lineItem.data('cart-item-index')
    var removeMessage = this._getRemoveMessage(lineItem)
    var $lineItemAtIndex

    if (index - 1 === 0) {
        $lineItemAtIndex = $('[data-cart-item-index="1"]', this.$container)
        $(removeMessage).insertBefore($lineItemAtIndex)
    } else {
        $lineItemAtIndex = $('[data-cart-item-index="' + (index - 1) + '"]', this.$container)
        removeMessage.insertAfter($lineItemAtIndex)
    }
    removeMessage.focus()
}

function _getRemoveMessage(lineItem) {
    var formattedMessage = this._formatRemoveMessage(lineItem)

    var $tableCell = $(selectors.cartTableCell, lineItem).clone()
    $tableCell
        .removeClass()
        .addClass(classes.cartRemovedProduct)
        .attr('colspan', '4')
        .html(formattedMessage)

    lineItem.attr('role', 'alert').html($tableCell).attr('tabindex', '-1')

    return lineItem
}

function _formatRemoveMessage(lineItem) {
    var quantity = lineItem.data('cart-item-quantity');
    var url = lineItem.attr(attributes.cartItemUrl);
    var vendor = lineItem.attr(attributes.cartItemVendor);
    var title = lineItem.attr(attributes.cartItemTitle);

    // Check if the removedItemMessage is defined
    console.log('Removed Item Message:', theme.strings.removedItemMessage); // Debugging

    var removedItemMessage = theme.strings && theme.strings.removedItemMessage
        ? theme.strings.removedItemMessage
        : 'You have removed [quantity] of <a href="[link]" class="text-link text-link--accent">[title]</a> from your cart.';

    return removedItemMessage
        .replace('[quantity]', quantity);
}

function _setCartCountBubble(quantity) {
    this.$cartCountBubble = this.$cartCountBubble || $(selectors.cartCountBubble)
    this.$cartCount = this.$cartCount || $(selectors.cartCount)
    if (quantity > 0) {
        this.$cartCountBubble.removeClass(classes.hide)
        this.$cartCount.html(quantity)
    } else {
        this.$cartCountBubble.addClass(classes.hide)
        this.$cartCount.html('0')
    }
}

function _emptyCart() {
    this.$emptyPageContent =
        this.$emptyPageContent || $(selectors.emptyPageContent, this.$container)
    this.$cartWrapper = this.$cartWrapper || $(selectors.cartWrapper, this.$container)

    // this.$emptyPageContent.removeClass(classes.hide);
    // this.$cartWrapper.addClass('classes.hide');
    $(selectors.emptyPageContent).removeClass(classes.hide)
    $(selectors.cartWrapper).addClass(classes.hide)
}

function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled

    if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
    }
    return cookieEnabled
}

theme.HaloAddOn = (function () {
  function modal_open(modal, name) {
    var classes = {
      open: 'open_' + name,
      openClass: 'modal--is-active',
    }

    $(modal).show('fast')
    $(modal).addClass(classes.openClass)
    $('body').addClass(classes.open)
  }

  function modal_close(modal, name) {
    var classes = {
      open: 'open_' + name,
      openClass: 'modal--is-active',
    }

    $(modal).hide('fast')
    $(modal).removeClass(classes.openClass)
    $('body').removeClass(classes.open)
  }
  function closeEmailModalWindow(newsletterWrapper, expire) {
    newsletterWrapper.hide(700)
    var inputChecked = newsletterWrapper.find('input[name="dismiss"]').prop('checked')
    if (inputChecked || !newsletterWrapper.find('input[name="dismiss"]').length)
      $.cookie('emailSubcribeModal', 'closed', {
        expires: expire,
        path: '/',
      })
  }

  function newsLetterPopup() {
    if (!$('#halo_newsletter').length) {
      return
    }

    var newsletterWrapper = $('#halo_newsletter'),
      overlay = newsletterWrapper.find('.popup-overlay'),
      closeWindow = newsletterWrapper.find('.close'),
      delay = $('.newsletterPopup').data('delay'),
      expire = $('.newsletterPopup').data('expire'),
      modalContent = newsletterWrapper.find('.newsletterPopup')

    if ($.cookie('emailSubcribeModal') != 'closed') {
      setTimeout(function () {
        newsletterWrapper.show(700)
      }, delay)
    }

    closeWindow.on('click', function (e) {
      e.preventDefault()
      closeEmailModalWindow(newsletterWrapper, expire)
    })

    overlay.on('click', function (e) {
      e.preventDefault()
      closeEmailModalWindow(newsletterWrapper, expire)
    })

    $('#mc_embed_signup form').submit(function () {
      if ($('#mc_embed_signup .email').val() != '') {
        closeEmailModalWindow(newsletterWrapper, expire)
      }
    })
  }
  function initDropdownMenu() {
    $('.nav-default .nav-bar .site-nav .item').on('mouseover', function (t) {
      $('.wrapper-navigation').addClass('overlay-open')
    }),
      $('.nav-bar .site-nav .item').on('mouseleave', function (t) {
        $('.wrapper-navigation').removeClass('overlay-open')
      })
  }

  return {
    init: function () {
      newsLetterPopup()
      initDropdownMenu()
      this.progressBarShipping()
      this.updateImageVariant()
      this.initToggleWidgetTitleSidebarFilter()
      this.initNavSubHover()
      this.updateImageVariantCol()
      this.smoothScrolling()
    },
    editCartPopup: function () {
      var $editCart = '#cart-edit-modal',
        $Close = $($editCart).find('.close'),
        $editCartContent = $($editCart).find('.cart-edit-modal')

      if (!$($editCart).length) {
        return
      }

      modal_open($editCart, 'popup_editCart')

      $Close.on('click', function (event) {
        event.preventDefault()
        modal_close($editCart, 'popup_editCart')
      })

      $($editCart).on('click', function (event) {
        if (
          $($editCart).hasClass('modal--is-active') &&
          $(event.target).closest($editCartContent).length === 0
        ) {
          event.preventDefault()
          modal_close($editCart, 'popup_editCart')
        }
      })
    },
    smoothScrolling: function () {
      $(
        '.item--cart .navUser-action,.cart-icon a, .acc-mb a, .navUser-action .navUser-text-wrapper a'
      )
        .off('click.scrollTop')
        .on('click', function (event) {
          if (this.hash !== '') {
            event.preventDefault()
            var hash = this.hash
            $('html, body').animate(
              {
                scrollTop: $(hash).offset().top,
              },
              1200
            )
          } // End if
        })
    },
    _setupSideCart: function () {
      if ($(window).width() >= 1200) {
        $('[data-cart-pc]').trigger('click')
      } else {
        $('[data-mobile-cart]').trigger('click')
      }
    },
    loadingPopup: function () {
      var $loading = '#loading-modal'
      modal_open($loading, 'popup_loading')
    },

    removeLoadingPopup: function () {
      var $loading = '#loading-modal'
      modal_close($loading, 'popup_loading')
    },
    updateImageVariantCol: function () {
      if (!$('.product-card__variant').length) {
        return
      }
      $(document).on(
        'click',
        '.product-card__variant .product-card__variant--item .item-label',
        function () {
          var self = $(this),
            $product = self.parents('.product-card'),
            $variantName = self.data('name'),
            $variantImage = self.data('image')
          $('.product-card__variant .product-card__variant--item .item-label').removeClass('active')
          self.addClass('active')

          if ($variantImage != '') {
            $product.find('.product-card__img').attr('src', $variantImage)
          }
        }
      )
    },
    progressBarShipping: function () {
      if ($('.cart__progress_bar').length) {
        var $priceFreeShip = parseInt(theme.strings.priceFreeShipping) * 100
        $.getJSON('/cart.js').then(function (cart) {
          var $cartTotalPrice = cart.total_price,
            $differencePrice = $priceFreeShip - $cartTotalPrice,
            $percent = Math.floor(($cartTotalPrice * 100) / $priceFreeShip)

          if ($percent > 100) $percent = 100

          if ($percent == 100) {
            var progress =
              '<div class="progress"><div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" style="width:' +
              $percent +
              '%" aria-valuenow="' +
              $percent +
              '" aria-valuemin="0" aria-valuemax="100">' +
              $percent +
              '%</div></div>'
            $('.progress_bar_shipping').addClass('success')
            $('.progress_bar_shipping').parent().addClass('active-shipping')
            $('.progress_bar_shipping').html(progress)
            $('.progress_bar_shipping_message').html(theme.strings.freeShipping)
          } else {
            if ($percent < 50) {
              var progress =
                '<div class="progress"><div class="progress-bar progress-bar-striped bg-danger progress-bar-animated" role="progressbar" style="width:' +
                $percent +
                '%" aria-valuenow="' +
                $percent +
                '" aria-valuemin="0" aria-valuemax="100">' +
                $percent +
                '%</div></div>'
            } else {
              var progress =
                '<div class="progress"><div class="progress-bar progress-bar-striped bg-warning progress-bar-animated" role="progressbar" style="width:' +
                $percent +
                '%" aria-valuenow="' +
                $percent +
                '" aria-valuemin="0" aria-valuemax="100">' +
                $percent +
                '%</div></div>'
            }
            var $price = theme.Currency.formatMoney($differencePrice, theme.moneyFormat)
            $('.progress_bar_shipping').removeClass('success')
            $('.progress_bar_shipping').parent().removeClass('active-shipping')
            $('.progress_bar_shipping').html(progress)
            $('.progress_bar_shipping_message').html(
              theme.strings.shippingMessage.replace('[price]', $price)
            )
          }

          if (theme.HaloAddOn.checkNeedToConvertCurrency()) {
            Currency.convertAll(
              window.shop_currency,
              $('#currencies .active').attr('data-currency'),
              'span.money',
              'money_format'
            )
          }
        })
      }
    },
    updateImageVariant: function () {
      if (!$('.product-card__variant').length) {
        return
      }
      $(document).on(
        'click',
        '.product-card__variant .product-card__variant--item label',
        function () {
          var self = $(this),
            $product = self.parents('.product-card'),
            $variantName = self.data('name'),
            $variantImage = self.data('image')
          $('.product-card__variant .product-card__variant--item label').removeClass('active')
          self.addClass('active')

          if ($variantImage != '') {
            $product.find('.product-card__img').attr('src', $variantImage)
          }
        }
      )
    },
    initToggleWidgetTitleSidebarFilter: function () {
      var widgetTitleSlt = '[data-has-collapse] .sidebarBlock-heading'

      $('body')
        .off('click.toggleWidgetContent')
        .on('click.toggleWidgetContent', widgetTitleSlt, function () {
          $(this).toggleClass('open')
          $(this).next().slideToggle()
        })
    },
    initNavSubHover: function () {
      $('[data-nav] .no-mega-menu').hover(function () {
        var rtl =
          $(window).width() -
          ($(this).find('.sub-menu-mobile ').offset().left +
            $(this).find('.sub-menu-mobile').outerWidth())
        if (rtl < 0) {
          $(this).find('.menu-lv-2 .sub-menu-mobile').css({ left: -242 })
        }
      })
    },
    checkNeedToConvertCurrency: function () {
      return (
        (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) ||
        window.show_auto_currency
      )
    },
  }
})()


function getSizedImageUrl(src, size) {
  var src = 'https://cdn.shopify.com/s/files/1/0639/4989/7957/products/10253986-a.jpg';
    if (size === null) {
        return src;
    }

    if (size === 'master') {
        return this.removeProtocol(src);
    }

    // Regular expression to match common image file extensions
    var regex = /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i;
    var match = src.match(regex);

    console.log('Image URL:', src);
    console.log('Regex Match:', match);

    if (match !== null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        console.log('Prefix:', prefix[0]);
        console.log('Suffix:', suffix);

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    console.warn('No image extension found in URL:', src);
    return null;
}
function removeProtocol(path) {
    return path.replace(/http(s)?:/, '')
}

function _showErrorMessage(errorMessage) {
    $(this.selectors.errorMessage, this.$container).html(errorMessage)

    if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError)
    }

    this.$errorMessageWrapper
        .removeClass(this.classes.productFormErrorMessageWrapperHidden)
        .attr('aria-hidden', true)
        .removeAttr('aria-hidden')
}

function _updateVlueQuantity(){
    $('form[data-cart-form] [data-qtt-edcart]')
        .off('click')
        .on('click', function (e) {
            e.preventDefault()
            var self = $(this)
            var $target = self.siblings('input[name="updates[]"]')
            var currentVal = parseInt($target.val())
            //=================
            if (self.hasClass('minus')) {
                if (currentVal >= 1) $target.val(currentVal - 1)
            } else {
                $target.val(currentVal + 1)
            }
            $target.trigger('change', function (e) {
                Cart.prototype._handleInputQty(e)
            })
        })
}
function getItem(key, state) {
    return state.items.find(function (item) {
        return item.key === key
    })
}
function _liveRegionText(variant) {
    // Dummy content for live region
    var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]'

    // Update availability
    if ($('#lang-switcher .dropdown-item.active').data('value') == '2') {
        if (!variant) {
            liveRegionText = theme2.strings.unavailable
            return liveRegionText
        }

        var availability = variant.available ? '' : theme2.strings.soldOut + ','
    } else {
        if (!variant) {
            liveRegionText = theme.strings.unavailable
            return liveRegionText
        }

        var availability = variant.available ? '' : theme.strings.soldOut + ','
    }

    liveRegionText = liveRegionText.replace('[Availability]', availability)

    // Update pricing information
    var regularLabel = ''
    var regularPrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat)
    var saleLabel = ''
    var salePrice = ''
    var unitLabel = ''
    var unitPrice = ''

    if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice
        regularPrice = theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + ','
        saleLabel = theme.strings.sale
        salePrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat)
    }

    if (variant.unit_price) {
        unitLabel = theme.strings.unitPrice
        unitPrice =
            theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
            ' ' +
            theme.strings.unitPriceSeparator +
            ' ' +
            this._getBaseUnit(variant)
    }

    liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .replace('[UnitPrice]', unitLabel)
        .replace('[$$$]', unitPrice)
        .trim()

    return liveRegionText
}
function _updateLiveRegion(item) {
    var $liveRegion = $(selectors.cartStatus)
    $liveRegion.html(this._liveRegionText(item)).attr('aria-hidden', false)

    // hide content from accessibility tree after announcement
    setTimeout(function () {
        $liveRegion.attr('aria-hidden', true)
    }, 1000)
}
function _hideErrorMessage() {
    // this.$errorMessageWrapper.addClass(this.classes.productFormErrorMessageWrapperHidden)

    // if (this.$quantityInput.length !== 0) {
    //     this.$quantityInput.removeClass(this.classes.inputError)
    // }
}

theme.Images = (function () {
  /**
  * Preloads an image in memory and uses the browsers cache to store it until needed.
  *
  * @param {Array} images - A list of image urls
  * @param {String} size - A shopify image size attribute
  */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images]
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i]
      this.loadImage(this.getSizedImageUrl(image, size))
    }
  }

  /**
  * Loads and caches an image in the browsers cache.
  * @param {string} path - An image url
  */
  function loadImage(path) {
    new Image().src = path
  }

  /**
  * Swaps the src of an image for another OR returns the imageURL to the callback function
  * @param image
  * @param element
  * @param callback
  */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src)
    var imageUrl = this.getSizedImageUrl(image.src, size)

    if (callback) {
      callback(imageUrl, image, element) // eslint-disable-line callback-return
    } else {
      element.src = imageUrl
    }
  }

  /**
  * +++ Useful
  * Find the Shopify image attribute size
  *
  * @param {string} src
  * @returns {null}
  */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    )

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2]
      } else {
        return match[1]
      }
    } else {
      return null
    }
  }

  /**
  * +++ Useful
  * Adds a Shopify size attribute to a URL
  *
  * @param src
  * @param size
  * @returns {*}
  */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src
    }

    if (size === 'master') {
      return this.removeProtocol(src)
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i)

    if (match !== null) {
      var prefix = src.split(match[0])
      var suffix = match[0]

      return this.removeProtocol(prefix[0] + '_' + size + suffix)
    }

    return null
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '')
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  }
})()

theme.Currency = (function () {
  var moneyFormat = '${{amount}}' // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '')
    }
    var value = ''
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    var formatString = format || moneyFormat

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ','
      decimal = decimal || '.'

      if (isNaN(number) || number === null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      var parts = number.split('.')
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
      var centsAmount = parts[1] ? decimal + parts[1] : ''

      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ')
        break
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'")
        break
    }

    return formatString.replace(placeholderRegex, value)
  }

  return {
    formatMoney: formatMoney,
  }
})()